// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__Qkd8-","list":"BalanceDue_list__9nDzx","listRow":"BalanceDue_listRow__2kX_a","total":"BalanceDue_total__1JqeK"};